import React, { Fragment } from "react";
import { Route, Redirect } from "react-router-dom";
import { BrowserRouter as Router, Switch } from "react-router-dom";

import { SignInScreen } from "../screens/signin/SignInScreen";
import { useAuthenticationContext } from "../context/UserContext";
import { SignupScreen } from "../screens/signup/SignupScreen";
import { SignOutScreen } from "../screens/signout/SignOut";
import { HomeScreen } from "../screens/home/HomeScreen";
import { BusinessSearchScreen } from "../screens/business-search/BusinessSearchScreen";
import { CheckInvitationCodeScreen } from "../screens/check-invitation-code/CheckInvitationCodeScreen";
import { CreateBusinessScreen } from "../screens/create-business/CreateBusinessScreen";
import { BusinessOwnerDashboardScreen } from "../screens/business_owner_dashboard_screen/BusinessOwnerDashboardScreen";
import { BranchManagerDashboardScreen } from "../screens/branch_manager_dashboard_screen/BranchManagerDashboardScreen";
import { BusinessOwnerAccountScreen } from "../screens/business_owner_account_screen/BusinessOwnerAccountScreen";
import { BranchManagerAccountScreen } from "../screens/branch_manager_account_screen/BranchManagerAccountScreen";
import { ICIPAdminSettingsScreen } from "../screens/admin-settings-screen/ICIPAdminSettingsScreen";
import { ICIPAdminScreen } from "../screens/icip_admin_screen/ICIPAdminScreen";
import { PrivacyPolicyScreen } from "./static/PrivacyPolicyScreen";
import { SupportScreen } from "./static/SupportScreen";
import { PublicRaffleDrawWinners } from "../screens/public/PublicRaffleDrawWinners";
import { PublicFaqsList } from "../screens/public/PublicFaqsList";
import { DeleteAccountInfo } from "../screens/public/DeleteAccountInfo";
import NotFoundPage from "../screens/errors/404";
import InternalErrorPage from "../screens/errors/500";
import ForbiddenPage from "../screens/errors/401";
import AdminSignIn from "../screens/admin-signin-v2/AdminSignIn";
import { Delete } from "@material-ui/icons";

enum RouteGuard {
  admin,
  personal,
  guest,
}

export const AppRoute = ({
  component: Component,
  guard,
  path,
  isPrivate,
  ...rest
}) => {
  const [authUser, token] = useAuthenticationContext();
  const isConnected = Boolean(token !== null) && Boolean(authUser !== null);

  const handleGuardAction = (props) => {
    if (!isPrivate) {
      return <Component {...props} />;
    }

    if (!isConnected) {
      return <Redirect to={{ pathname: SignInScreen.routeName }} />;
    }

    // Connected use!! Compute navigation permission
    if (guard === RouteGuard.admin) {
      if (!authUser.isAdmin()) {
        return <Redirect to={{ pathname: ForbiddenPage.routeName }} />;
      }
    }

    /*if (guard === RouteGuard.personal) {
      if (!authUser.isPersonal() || !authUser.isOwner() || !authUser.isEmployee()) {
        return <Redirect to={{ pathname: ForbiddenPage.routeName }} />;
      }
    }*/

    return <Component {...props} />;
  };

  return <Route path={path} render={handleGuardAction} {...rest} />;
};

export const AppRouter = () => {
  return (
    <Router>
      <Switch>
        <AppRoute
          component={SignInScreen}
          path={SignInScreen.routeName}
          isPrivate={false}
          exact={true}
          guard={RouteGuard.guest}
        />
        <AppRoute
          component={SignupScreen}
          path={SignupScreen.routeName}
          isPrivate={false}
          exact={true}
          guard={RouteGuard.guest}
        />
        <AppRoute
          component={SignOutScreen}
          path={SignOutScreen.routeName}
          isPrivate={true}
          exact={true}
          guard={RouteGuard.guest}
        />
        <AppRoute
          component={HomeScreen}
          path={HomeScreen.routeName}
          isPrivate={true}
          exact={true}
          guard={RouteGuard.personal}
        />
        <AppRoute
          component={BusinessSearchScreen}
          path={BusinessSearchScreen.routeName}
          isPrivate={true}
          exact={true}
          guard={RouteGuard.personal}
        />
        <AppRoute
          component={CheckInvitationCodeScreen}
          path={CheckInvitationCodeScreen.routeName}
          isPrivate={true}
          exact={true}
          guard={RouteGuard.personal}
        />
        <AppRoute
          component={CreateBusinessScreen}
          path={CreateBusinessScreen.routeName}
          isPrivate={true}
          exact={true}
          guard={RouteGuard.personal}
        />
        <AppRoute
          component={BusinessOwnerDashboardScreen}
          path={BusinessOwnerDashboardScreen.routeName}
          isPrivate={true}
          guard={RouteGuard.personal}
        />
        <AppRoute
          component={BranchManagerDashboardScreen}
          path={BranchManagerDashboardScreen.routeName}
          isPrivate={true}
          guard={RouteGuard.personal}
        />
        <AppRoute
          component={BusinessOwnerAccountScreen}
          path={BusinessOwnerAccountScreen.routeName}
          isPrivate={true}
          guard={RouteGuard.personal}
        />
        <AppRoute
          component={BranchManagerAccountScreen}
          path={BranchManagerAccountScreen.routeName}
          isPrivate={true}
          guard={RouteGuard.personal}
        />
        <AppRoute
          layout={Fragment}
          component={ICIPAdminSettingsScreen}
          path={ICIPAdminSettingsScreen.routeName}
          isPrivate={true}
          exact={true}
          guard={RouteGuard.admin}
        />
        <AppRoute
          layout={Fragment}
          component={ICIPAdminScreen}
          path={ICIPAdminScreen.routeName}
          isPrivate={true}
          exact={true}
          guard={RouteGuard.admin}
        />
        <AppRoute
          layout={Fragment}
          component={AdminSignIn}
          path={AdminSignIn.routeName}
          isPrivate={false}
          exact={true}
          guard={RouteGuard.guest}
        />
        <AppRoute
          layout={Fragment}
          component={PrivacyPolicyScreen}
          path={PrivacyPolicyScreen.routeName}
          isPrivate={false}
          exact={true}
          guard={RouteGuard.guest}
        />
        <AppRoute
          layout={Fragment}
          component={SupportScreen}
          path={SupportScreen.routeName}
          isPrivate={false}
          exact={true}
          guard={RouteGuard.guest}
        />
        <AppRoute
          component={PublicRaffleDrawWinners}
          path={PublicRaffleDrawWinners.routeName}
          isPrivate={false}
          exact={true}
          guard={RouteGuard.guest}
        />
        <AppRoute
          component={PublicFaqsList}
          path={PublicFaqsList.routeName}
          isPrivate={false}
          exact={true}
          guard={RouteGuard.guest}
        />
        <AppRoute
          component={DeleteAccountInfo}
          path={DeleteAccountInfo.routeName}
          isPrivate={false}
          exact={true}
          guard={RouteGuard.guest}
        />

        <AppRoute
          isPrivate={false}
          exact
          path={NotFoundPage.routeName}
          component={NotFoundPage}
          guard={RouteGuard.guest}
        />
        <AppRoute
          isPrivate={false}
          exact
          path={ForbiddenPage.routeName}
          component={ForbiddenPage}
          guard={RouteGuard.guest}
        />
        <AppRoute
          isPrivate={false}
          exact
          path={InternalErrorPage.routeName}
          component={InternalErrorPage}
          guard={RouteGuard.guest}
        />
        <NotFoundPage />
      </Switch>
    </Router>
  );
};
